<div class="text-align-center">
  <h3 class="t-5@r color-void mb-4">Remove Conversation</h3>

  <div class="mb-6">Are you sure you want to remove this conversation?</div>

  <div class="grid">
    <button class="g-col-6" sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-red'" (click)="confirm()">
      Remove
    </button>
    <button class="g-col-6" sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="close()">
      Cancel
    </button>
  </div>
</div>
